import React from "react";
import "./franchiseSidebarModal.css";

const TITLES = {
    "add-section": "Add section",
    "edit-section": "Edit section",
    "add-sub": "Add sub-section",
    "edit-sub": "Edit sub-section",
};

const FranchiseSidebarModal = ({
    sidebarModal,
    setSidebarModal,
    sidebarLoading,
    uploadingIcon,
    iconDragOver,
    setIconDragOver,
    iconInputRef,
    handleIconFileChange,
    handleIconDrop,
    removeIcon,
    closeSidebarModal,
    submitSidebarModal,
}) => {
    if (!sidebarModal) return null;

    const isEdit = sidebarModal.mode.startsWith("edit");

    return (
        <div className="fsm-overlay" onClick={closeSidebarModal}>
            <div className="fsm-modal" onClick={(e) => e.stopPropagation()}>
                <div className="fsm-header">
                    <h3>{TITLES[sidebarModal.mode]}</h3>
                    <button type="button" className="fsm-close" onClick={closeSidebarModal} aria-label="Close">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>

                <div className="fsm-avatar-row">
                    <div
                        className={`fsm-avatar ${iconDragOver ? "fsm-avatar--over" : ""}`}
                        onClick={() => iconInputRef.current?.click()}
                        onDragOver={(e) => { e.preventDefault(); setIconDragOver(true); }}
                        onDragLeave={() => setIconDragOver(false)}
                        onDrop={handleIconDrop}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === "Enter" && iconInputRef.current?.click()}
                    >
                        {sidebarModal.icon ? (
                            <img src={sidebarModal.icon} alt="" />
                        ) : (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <rect x="3" y="3" width="18" height="18" rx="5" />
                                <circle cx="8.5" cy="8.5" r="1.5" />
                                <polyline points="21 15 16 10 5 21" />
                            </svg>
                        )}

                        {uploadingIcon && (
                            <div className="fsm-avatar-overlay">
                                <svg className="fsm-spinner" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                                </svg>
                            </div>
                        )}

                        <button
                            type="button"
                            className="fsm-avatar-edit"
                            onClick={() => iconInputRef.current?.click()}
                            disabled={uploadingIcon}
                            aria-label="Change icon"
                        >
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M12 20h9" />
                                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
                            </svg>
                        </button>

                        <input
                            ref={iconInputRef}
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleIconFileChange}
                        />
                    </div>

                    <div className="fsm-avatar-meta">
                        <span className="fsm-field-label">Icon</span>
                        {sidebarModal.icon ? (
                            <button type="button" className="fsm-link fsm-link--danger" onClick={removeIcon} disabled={uploadingIcon}>
                                Remove
                            </button>
                        ) : (
                            <span className="fsm-avatar-hint">{iconDragOver ? "Drop to upload" : "Click or drop an image"}</span>
                        )}
                    </div>
                </div>

                <div className="fsm-row">
                    <div className="fsm-field">
                        <label className="fsm-field-label">Key</label>
                        <input
                            type="text"
                            className="fsm-input"
                            value={sidebarModal.key}
                            disabled={isEdit}
                            onChange={(e) =>
                                setSidebarModal((prev) => ({
                                    ...prev,
                                    key: e.target.value.trim().toLowerCase().replace(/\s+/g, "_"),
                                }))
                            }
                        />
                        {isEdit && <span className="fsm-hint">Can't be changed after creation</span>}
                    </div>
                    <div className="fsm-field fsm-field--order">
                        <label className="fsm-field-label">Order</label>
                        <input
                            type="number"
                            className="fsm-input"
                            value={sidebarModal.order}
                            onChange={(e) => setSidebarModal((prev) => ({ ...prev, order: Number(e.target.value) }))}
                        />
                    </div>
                </div>

                <div className="fsm-field">
                    <label className="fsm-field-label">Name</label>
                    <input
                        type="text"
                        className="fsm-input"
                        value={sidebarModal.name}
                        onChange={(e) => setSidebarModal((prev) => ({ ...prev, name: e.target.value }))}
                    />
                </div>

                {isEdit && (
                    <label className="fsm-toggle-row">
                        <span>Active</span>
                        <span className="fsm-switch">
                            <input
                                type="checkbox"
                                checked={!!sidebarModal.is_active}
                                onChange={(e) => setSidebarModal((prev) => ({ ...prev, is_active: e.target.checked }))}
                            />
                            <span className="fsm-switch-track" />
                        </span>
                    </label>
                )}

                <div className="fsm-footer">
                    <button type="button" className="fsm-btn" onClick={closeSidebarModal}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="fsm-btn fsm-btn--primary"
                        onClick={submitSidebarModal}
                        disabled={sidebarLoading}
                    >
                        {sidebarLoading ? "Saving…" : "Save"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FranchiseSidebarModal;